// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"_3rIH4vBsb0-dIn2ScMJ52L","carouselSlider":"I2Pfnw2MN97c6wkdZZ4Hg"};